import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
  SidebarComponent, 
  SidebarMenuItem, 
  SidebarCallToAction, 
  SidebarFooterItem 
} from '../../shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-provider-sidebar',
  standalone: true,
  imports: [CommonModule, SidebarComponent],
  templateUrl: './provider-sidebar.component.html',
  styleUrl: './provider-sidebar.component.scss',
})
export class ProviderSidebarComponent {
  menuItems: SidebarMenuItem[] = [
    {
      label: 'Dashboard',
      route: '/provider/home',
      iconUrl: '/icons/dashboard.svg',
    },
    {
      label: 'My Activities',
      route: '/provider/activities',
      iconUrl: '/icons/activities.svg',
    },
    {
      label: 'My Projects',
      route: '/provider/my-projects',
      iconUrl: '/icons/folder.svg',
    },
    {
      label: 'Assets',
      icon: '<path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      children: [
        {
          label: 'Add Dataset',
          route: '/provider/add-contributions/add-dataset',
        },
        {
          label: 'Add Model',
          route: '/provider/add-contributions/add-model',
        },
        {
          label: 'Manage Assets',
          route: '/provider/manage-contributions',
        },
        {
          label: 'Access Requests',
          route: '/provider/access-requests',
        },
      ],
    },
    {
      label: 'Organisation',
      route: '/provider/data-provider-entity',
      icon: '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 2C15 6 15 18 12 22C9 18 9 6 12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    },
  ];

  callToAction: SidebarCallToAction | undefined = undefined;

  footerItems: SidebarFooterItem[] = [
    {
      label: 'Profile',
      route: '/provider/profile',
      iconUrl: '/icons/person.svg',
    },
    {
      label: 'Support',
      route: '/provider/support',
      iconUrl: '/icons/support.svg',
    },
  ];
}

